import React from "react";

export const CAPABILITY_LABELS = {
  mail: "Email", filesystem: "Files", shell: "Shell commands", cloud_admin: "Cloud / admin APIs",
  database: "Databases", browser: "Browser", payments: "Payments / wallets",
};

// Broad access the server has (high_privilege_scope). A capability, not a verdict: shown as text badges.
export default function CapabilityBadges({ capabilities, testid = "capability-badges" }) {
  const caps = capabilities || [];
  if (!caps.length) return null;
  return (
    <span data-testid={testid} style={{ display: "inline-flex", gap: 6, flexWrap: "wrap" }}>
      {caps.map((c) => <span key={c} className="hs-badge hs-badge-warning" data-testid={`capability-${c}`}>{CAPABILITY_LABELS[c] || c}</span>)}
    </span>
  );
}
